import { gql } from '@apollo/client';

export const FETCH_INVOICE_PDF = gql`
  query getInvoicePdf($id: ID!) {
    pdf: getInvoicePDF(id: $id) {
      url
    }
  }
`;
